import Vue from 'vue';
import Router from 'vue-router';
import { setTitle } from '@/utils/util';
import { OPT } from '@/utils/ubtUtils';
import { Toast } from 'vant';
import routes from './routes';

Vue.use(Router);

const router = new Router({
  routes,
});

router.beforeEach((to, from, next) => {
  const { title } = to.meta;
  if (title) setTitle(title);
  const pageName = (to || {}).path;
  const referPageName = (from || {}).path || '/';
  OPT.pageviewFlow(pageName, referPageName === '/' ? '首页' : '');
  next();
});

router.onError((err) => {
  if (err && err.name === 'ChunkLoadError') {
    Toast('网络异常，请稍后再试');
  }
});

export default router;
